module.exports = __webpack_public_path__ + "img/GRANDPARENTS DAY.3b1b395.svg";